/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as manipulações de regionais
 * @author Bene Lemuel Dantas Gondim
 * @file orgao.regionalReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'

// Estado inicial da sessão no redux
const initialState = {
  regionais: [],
  error: null,
  nomeFuncao: '',
  dados: {
    id: '',
    nome: '',
    sigla: '',
    descricao: '',
    orgao: '',
  },
}

const regionaisReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_REGIONAIS: {
      return {
        ...state,
        regionais: action.regionais,
      }
    }

    default: {
      return state
    }
  }
}

export default regionaisReducer
